import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IRelated} from "../../components/Cards/types";

interface ActiveTVState {
    activeTV: IRelated | null;
    listTV: IRelated[];
    selectedTV: boolean,
}

const initialState: ActiveTVState = {
    activeTV: null,
    selectedTV: false,
    listTV: []
};

const activeTVSlice = createSlice({
    name: "activeTV",
    initialState,
    reducers: {
        setActiveTV: (state, action: PayloadAction<IRelated>) => {
            state.activeTV = action.payload;
        },
        setListTV: (state, action: PayloadAction<IRelated[]>) => {
            state.listTV = action.payload;
        },
        setSelectedTV: (state, action: PayloadAction<boolean>) => {
            state.selectedTV = action.payload;
        },
    },
});

export const {setActiveTV,setSelectedTV, setListTV} = activeTVSlice.actions;

export default activeTVSlice.reducer;
